import React from 'react';
import PropTypes from "prop-types";

import Label from "./Label";
import RangeSelector from "./RangeSelector";
import Dates from "./Dates";

import './date_range_selector.scss';

const DateRangeSelector = function (
    {
        onUpdate,
        from,
        till,
        with_label,
        label,
        as,
        days = [],
        numberOfMonths = 3,
        item_class = '',
        trigger_class = ''
    }
) {
    return (
        <div className='mindsets-date-range-selector'>
            <Label with_label={with_label} label={label}/>
            <div className={'mindsets-date-range-selector-container' + (as === 'buttons' ? ' as-buttons' : '')}>
                <RangeSelector
                    from={from}
                    till={till}
                    as={as}
                    onUpdate={onUpdate}
                    item_class={item_class}
                    trigger_class={trigger_class}
                />
                <Dates
                    from={from}
                    till={till}
                    onUpdate={onUpdate}
                    days={days}
                    numberOfMonths={numberOfMonths}/>
            </div>
        </div>
    );
};

DateRangeSelector.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    from: PropTypes.number,
    till: PropTypes.number,
    numberOfMonths: PropTypes.number,
    with_label: PropTypes.bool,
    label: PropTypes.string,
    as: PropTypes.string,
    days: PropTypes.array,
    item_class: PropTypes.string,
    trigger_class: PropTypes.string
}

export default DateRangeSelector;
